import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import FontFaceObserver from 'fontfaceobserver';

// Apollo client
import client from './graphql-client';

// Root component
import Root from './routes';

// Import styles
import 'normalize.css';
import './styles/main.scss';
import 'tippy.js/themes/light.css';

// Wait for Open Sans font to load
const fontLight = new FontFaceObserver('Open Sans', {
  weight: 300
});
const fontNormal = new FontFaceObserver('Open Sans');
const fontMedium = new FontFaceObserver('Open Sans', {
  weight: 500
});
const fontBold = new FontFaceObserver('Open Sans', {
  weight: 600
});
const fontBlack = new FontFaceObserver('Open Sans', {
  weight: 700
});

console.log('loading fonts...');
Promise.all([
  fontLight.load(),
  fontNormal.load(),
  fontMedium.load(),
  fontBold.load(),
  fontBlack.load()
]).then(() => {
  console.log('fonts loaded');
  ReactDOM.render(
    <Router>
      <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
          <Root />
        </ApolloHooksProvider>
      </ApolloProvider>
    </Router>,
    document.getElementById('root')
  );
});
